import { render } from "./HorsePendingTable.vue?vue&type=template&id=3b4b00aa"
import script from "./HorsePendingTable.vue?vue&type=script&lang=js"
export * from "./HorsePendingTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__